<template>
    <div class="MainBox del-box">
        <img src="https://p6.moimg.net/mdwxapp/empty_comment_icon.png" />
        <p>{{props.message || '您还没有发起项目'}}</p>
        <el-button v-if="props.message == '您还没有发起项目'" type="primary" @click="goInitiate">发起众筹项目</el-button>
        <el-button v-if="props.type == 'wds'" type="primary" @click="goOld">立即前往</el-button>
    </div>
</template>

<script setup>
import domain from '@/service/domain'
const props = defineProps(['message', 'type', 'pro_id'])
const goInitiate = () => {
    window.open(`${domain.account}/initiate`)
}
const goOld = () => {
    if (props.pro_id) {
        window.open(`${domain.zhongchou}/project_new_wds/pro_cover?id=${props.pro_id}`)
    }
}
</script>

<style lang="scss" scoped>
.del-box {
        min-height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        img {
            width: 130px;
            height: 130px;
        }
        p {
            color: #9E9E9E;
            font-size: 12px;
            margin-bottom: 10px;
        }
}
</style>
